import { useMemo } from 'react'
import { useReadableMembershipInfo } from '@components/TownPageLayout/useReadableMembershipInfo'
import { readableDuration } from '@components/Web3/Subscriptions/SubscriptionsPanel'
import { useEthPrice } from '@components/Web3/useEthPrice'
import { Text } from '@ui'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { useContractSpaceInfo } from 'use-towns-client'
import { shouldDisplayFreeText } from 'utils/shouldDisplayFreeText'

export const MembershipPriceDisplay = (props: { spaceId: string | undefined }) => {
    const { spaceId } = props
    const { data: contractSpaceInfo } = useContractSpaceInfo(spaceId)
    const { enableUsdc } = useFeatureFlags()
    const { data: ethPrice } = useEthPrice({
        enabled: enableUsdc,
    })
    const { data: readableMembershipInfo } = useReadableMembershipInfo(
        contractSpaceInfo?.networkId ?? '',
        {
            showEthInUsd: enableUsdc,
            ethPrice,
        },
    )

    const membershipPriceDisplay = useMemo(() => {
        const price = readableMembershipInfo?.price
        const currency = readableMembershipInfo?.currency
        const duration = readableMembershipInfo?.duration

        if (!price) {
            return undefined
        }

        if (shouldDisplayFreeText(price)) {
            return 'Free'
        }

        const priceText = enableUsdc ? price : `${price} ${currency === 'ETH' ? currency : ''}`

        // Add duration if available (e.g., "0.01 ETH Yearly")
        if (duration) {
            const durationText = readableDuration(duration)
            return `${priceText} ${durationText}`
        }

        return priceText
    }, [
        readableMembershipInfo?.currency,
        readableMembershipInfo?.price,
        readableMembershipInfo?.duration,
        enableUsdc,
    ])

    return (
        <Text strong color="positive" fontSize="lg" whiteSpace="nowrap">
            {membershipPriceDisplay}
        </Text>
    )
}
